// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TKLZY","col":"styles_col__45YWZ"};